<template lang="pug">
div(v-if="abrir_publicar")
	.card
		.card-body
			button.close(@click="$emit('cerrar')")
				span.fa.fa-close
			h6
				b Publicar
			textarea.form-control(placeholder="En que estás pensando...", v-model="nueva.Mensaje", @input="analizarMensaje")
		.card-body.bg-light
			h5 Adjuntar
			button.btn.btn-sm.m-2(@click="adjuntar()")
				span.fa.fa-upload.mr-2
				| Archivos
			button.btn.btn-sm.m-2(@click="editarEncuesta = true")
				span.fa.fa-bar-chart.mr-2
				| Encuesta
			button.btn.btn-sm.m-2(@click="panelGifs = true")
				span.fa.fa-gift.mr-2
				| Gif
		table.table.table-striped.m-0(v-if="nueva.Encuestas && nueva.Encuestas.length > 0")
			thead.bg-dark.text-white
				tr
					th(colspan="2")
						span.fa.fa-file.mr-2
						| Encuestas
			tbody
				tr(v-for="(encuesta, i) in nueva.Encuestas", :key="i")
					td(@click="editarEncuesta = encuesta") {{encuesta.Titulo}} ({{encuesta.Opciones.length}} opciones)
					td.text-right
						span.fa.fa-trash.text-danger(@click="delEncuesta(i)", style="cursor: pointer;")
		table.table.table-striped.m-0(v-if="nueva.Gifs && nueva.Gifs.length > 0")
			thead.bg-dark.text-white
				tr
					th(colspan="2")
						span.fa.fa-file.mr-2
						| Gifs
			tbody
				tr(v-for="(gif, i) in nueva.Gifs", :key="i")
					td(@click="eliminarGif(i)", style="cursor: pointer;")
						img(:src="gif.images.downsized_large.url", style="position:relative;width:100%;")
		table.table.table-striped.m-0(v-if="nueva.Archivos && nueva.Archivos.length > 0")
			thead.bg-dark.text-white
				tr
					th(colspan="2")
						span.fa.fa-file.mr-2
						| Archivos
			tbody
				tr(v-for="(archivo, i) in nueva.Archivos", :key="i")
					td {{archivo.name}}
					td.text-right
						span.fa.fa-trash.text-danger(@click="eliminarArchivo(i)", style="cursor: pointer;")
		div.p-1.bg-dark.text-white(v-if="nueva.Youtube && nueva.Youtube.length > 0")
			b.ml-2
				span.fa.fa-youtube.mr-2
				| Vídeos de youtube
		div.card-body(v-if="nueva.Youtube && nueva.Youtube.length > 0")
			div.youtubeCaption(
				v-for="id in nueva.Youtube"
				:key="id"
				@click="quitarVideo(id)"
				@mouseover="videoOver = id"
				@mouseleave="videoOver = null"
			)
				div.papelera.text-danger(:class="(videoOver === id) ? 'active' : ''")
					span.fa.fa-trash
				img(
					:src="'https://img.youtube.com/vi/' + id + '/0.jpg'"
					style="width: 80px;"
				)
		.card-footer
			button.btn.btn-primary(@click="publicar()", :disabled="!formValido")
				span.fa.fa-paper-plane.mr-2
				| Publicar
		EditorEncuesta(v-if="editarEncuesta", @cerrar="editarEncuesta = false", @updated="addEncuesta($event)", :encuesta="editarEncuesta")
		BuscarGifs(v-if="panelGifs", @cerrar="panelGifs = false", @adjuntar="nueva.Gifs.push($event)")
</template>

<script>
import axios from 'axios'
import EditorEncuesta from './editorEncuesta'
import BuscarGifs from './buscarGifs'
export default {
	props: {
		abrir_publicar: Boolean
	},
	components: {
		EditorEncuesta,
		BuscarGifs
	},
	data () {
		return {
			nueva: {
				PublicacionID: null,
				Mensaje: '',
				Archivos: [],
				Gifs: [],
				Encuestas: [],
				Youtube: []
			},
			panelGifs: false,
			videoOver: null,
			editarEncuesta: false
		}
	},
	computed: {
		formValido () {
			if (!this.nueva.Mensaje) {
				return false
			}
			return true
		},
		hayAdjuntos () {
			return (
				(this.nueva.Archivos && this.nueva.Archivos.length > 0) ||
				(this.nueva.Encuestas && this.nueva.Encuestas.length > 0) ||
				(this.nueva.Youtube && this.nueva.Youtube.length)
			)
		}
	},
	methods: {
		adjuntar () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = true
			inp.addEventListener('change', (ev) => {
				for (let i = 0; i < inp.files.length; i++) {
					this.nueva.Archivos.push(inp.files[i])
				}

				document.body.removeChild(inp)
			})
			document.body.appendChild(inp)
			inp.click()
		},
		eliminarGif (i) {
			this.nueva.Gifs.splice(i, 1)
		},
		eliminarArchivo (i) {
			this.nueva.Archivos.splice(i, 1)
		},
		analizarMensaje () {
			// Buscamos enlaces de youtube
			const enlaceYoutube = /https:\/\/www\.youtube\.com\/[^\s]*v=([\w\d_-]+)/igm
			let enlaces = this.nueva.Mensaje.match(enlaceYoutube)
			let encontrados = []
			if (enlaces) {
				const expID = /v=([\w\d_-]*)/
				enlaces.forEach(e => {
					if (e) {
						const id = expID.exec(e)
						if (id) {
							if (this.nueva.Youtube.indexOf(id[1]) < 0) {
								encontrados.push(id[1])
							}
						}
					}
				})
			}

			this.nueva.Youtube = this.nueva.Youtube.concat(encontrados)
		},
		quitarVideo (id) {
			const i = this.nueva.Youtube.indexOf(id)

			if (i >= 0) {
				this.nueva.Youtube.splice(i, 1)
			}
		},
		addEncuesta (datos) {
			// Comprobamos si ya existe la encuesta
			for (let i = 0; i < this.nueva.Encuestas.length; i++) {
				if (this.nueva.Encuestas[i].EncuestaID === datos.EncuestaID) {
					this.nueva.Encuestas[i] = datos
					return
				}
			}

			this.nueva.Encuestas.push(datos)
		},
		delEncuesta (i) {
			this.nueva.Encuestas.splice(i, 1)
		},
		publicar () {
			const form = new FormData()
			if (this.nueva.Archivos.length > 0) {
				for (let i = 0; i < this.nueva.Archivos.length; i++) {
					form.append('ficheros[]', this.nueva.Archivos[i])
				}
			}

			const datos = JSON.parse(JSON.stringify(this.nueva))
			delete datos.Archivos
			form.append('datos', JSON.stringify(datos))

			axios.post('muro/php/api/setPublicacion.php', form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
				.then(res => {
					this.$store.commit('muro/ADD_PUBLICACION', res.data)

					this.nueva = {
						PublicacionID: null,
						Mensaje: '',
						Archivos: [],
						Encuestas: [],
						Youtube: [],
						Gifs: []
					}
					this.$emit('cerrarPublicar')
				})
				.catch(e => {
					console.error(e.response.data)
				})
		}
	}
}
</script>

<style scoped>
.incluido > li {
	cursor: pointer;
}
.incluido > li:hover {
	color: blue;
}

.youtubeCaption {
	position: relative;
	display: inline-block;
	margin: 5px;
	cursor: pointer;
}

.papelera {
	position: absolute;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(255,255,255,0);
	opacity: 0;
	transition: 100ms all ease-in-out;
	font-size: 3.2em;
	text-align: center;
}

.papelera.active {
	background-color: rgba(255,255,255,0.7);
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/nueva/nuevaPublicacion.vue